module.exports = __webpack_public_path__ + "static/media/ComputerTalk_Step5_end_card.d7fd2ec6.jpg";